<template lang="pug">
div
    el-row(
    )
        el-col(
            :span="10"
        )
            sectionHeader(title="General")
            div.settings-section
                switchItem.section-item(
                    v-if="!isWeboEmployee"
                    label="Catalog"
                    type="general"
                    inputName="catalog"
                    :isSwitchActive="generalSettings.catalog"
                    :isDisabled="processing"
                    @change="onGeneralSettingChange($event, 'catalog', 'Account catalog')"
                )

                switchItem.section-item(
                    label="Demographic breakdown"
                    type="general"
                    inputName="demographicBreakdown"
                    :isSwitchActive="generalSettings.demographicBreakdown"
                    :isDisabled="processing"
                    @change="onGeneralSettingChange($event, 'demographicBreakdown', 'Demographic breakdown')"
                )

                switchItem.section-item(
                    label="Frequency"
                    type="general"
                    inputName="frequency"
                    :isSwitchActive="generalSettings.frequency"
                    :isDisabled="processing"
                    @change="onGeneralSettingChange($event, 'frequency', 'Frequency')"
                )

                switchItem.section-item(
                    label="3rd party quantile"
                    type="general"
                    inputName="quantile"
                    :isSwitchActive="generalSettings.quantile"
                    :isDisabled="processing"
                    @change="onGeneralSettingChange($event, 'quantile', '3rd party quantile')"
                )

                switchItem.section-item(
                    label="3rd party surf intensity"
                    type="general"
                    inputName="surfintensity"
                    :isSwitchActive="generalSettings.surfintensity"
                    :isDisabled="processing"
                    @change="onGeneralSettingChange($event, 'surfintensity', '3rd party surf intensity')"
                )

                switchItem.section-item(
                    label="Bootstrap and push of stock"
                    type="general"
                    inputName="bootstrapPush"
                    :isSwitchActive="generalSettings.bootstrapPush"
                    :isDisabled="generalSettings.catalog || processing"
                    @change="onGeneralSettingChange($event, 'bootstrapPush', 'Bootstrap and push of stock')"
                )

                switchItem.section-item(
                    :class="{'ui-disabled': userRole === 'webo_user'}"
                    label="Dashboard and alerts"
                    type="general"
                    inputName="dashboardAndAlerts"
                    :isSwitchActive="isDashboardAccessAllowed"
                    :isDisabled="processing"
                    @change="onGeneralSettingChange($event, 'dashboardAndAlerts', 'Dashboard and alerts')"
                )

                switchItem.section-item(
                    label="Cookie 1st"
                    type="general"
                    inputName="firstPartyCookie"
                    :isSwitchActive="generalSettings.firstPartyCookie"
                    :isDisabled="processing"
                    @change="onGeneralSettingChange($event, 'firstPartyCookie', 'Cookie 1st')"
                )
            //- X-DEVICE
            div.settings-section
                switchItem.header.h2(label="Cross device" type="general" inputName="xdevice" :isSwitchActive="generalSettings.xdevice")

                div.xdevice-info.l-flex-row(:class="{'ui-disabled': !uiGeneralSettings.xdevice}")
                    input(
                        type="radio"
                        name="centric"
                        id="centric"
                        value="account"
                        @change="setCallXDevice"
                        v-model="xDeviceScope"
                    )
                    label.xdevice-label(for="centric") Client centric metrics
                        p.sublabel-info Deterministic data from Client CRM, this data is available only if the client send CRM data to WAM.

                div.xdevice-info.l-flex-row(:class="{'ui-disabled': !uiGeneralSettings.xdevice}")
                    input(
                        type="radio"
                        name="shared"
                        id="shared"
                        value="pool"
                        @change="setCallXDevice"
                        v-model="xDeviceScope"
                    )
                    label.xdevice-label(for="shared") Shared metrics
                        p.sublabel-info Deterministic data from CRM of all client who accept to share its CRM, this option is available only if the client share its CRM data to the WAM pool.

        el-col(
            :span="10"
            :offset="2"
        )
            sectionHeader(title="Alternative Ids")

            div.settings-section

                switchItem.section-item(
                    label="First-id"
                    type="general"
                    inputName="providerFirstIdActivated"
                    :isSwitchActive="generalSettings.providerFirstIdActivated"
                    :isDisabled="processing"
                    @change="onGeneralSettingChange($event, 'providerFirstIdActivated', 'First-id')"
                )

                switchItem.section-item(
                    label="Utiq"
                    type="general"
                    inputName="providerUtiqActivated"
                    :isSwitchActive="generalSettings.providerUtiqActivated"
                    :isDisabled="processing"
                    @change="onGeneralSettingChange($event, 'providerUtiqActivated', 'Utiq')"
                )


</template>
<script>
//components
import SectionHeader from '@/components/common/SectionHeader'
import SwitchItem from '@/components/common/SwitchItem'

import { Row, Col } from 'element-ui'
//store
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import { get, isEqual, isNil } from 'lodash'
import { API_GENERAL_SETTINGS } from '@/utils/constants'

export default {
    components: {
        SectionHeader,
        SwitchItem,
        'el-row': Row,
        'el-col': Col
    },

    mounted() {
        if (this.hasUserAccessToSettings) {
            if (isNil(this.accountXDeviceScope) || this.accountXDeviceScope !== 'pool') this.xDeviceScope = 'account'
            else this.xDeviceScope = 'pool'
        }
    },
    data() {
        return {
            settingsMenu: 'general',
            xDeviceScope: '',
            callXDevice: false,
            processing: false,
        }
    },

    watch: {
        uiGeneralSettings: {
            handler: function(newValue) {
                if (!isNil(this.uiSettingName)) {
                    if (isEqual(this.uiSettingName, 'xdevice')) {
                        this.updateXDevice({ activate: newValue.xdevice, scope: this.xDeviceScope })
                    }
                }
            },
            deep: true
        },

        xDeviceScope: {
            handler: function() {
                if (this.callXDevice) {
                    if (this.uiSettingName !== 'xdevice') {
                        this.setSettingName({ name: 'xdevice' })
                    }
                    this.updateXDevice({ activate: true, scope: this.xDeviceScope })
                }
            }
        },

    },

    computed: {
        ...mapState('account', {
            accountXDeviceScope: state => get(state, 'xDeviceInfo.scope', null),
            userRole: state => state.userRole,
            isDashboardAccessAllowed: state => state.settings.allocationDashboardActivated
        }),

        ...mapState('data/settings', {
            generalSettings: state => state.general,
        }),
        ...mapState('ui/settings', {
            uiSettingName: state => state.settingName,
            uiGeneralSettings: state => state.general,
        }),
        ...mapGetters('account', ['getAccessToSettings']),

        hasUserAccessToSettings() {
            return this.getAccessToSettings()
        },

        isWeboEmployee() {
            return this.userRole === 'webo_employee'
        },
    },

    methods: {
        ...mapActions('data/settings', ['updateSettings', 'updateXDevice']),


        ...mapMutations('ui/settings', [
            'setSettingName',
            'setGeneralSetting',
            'setLoading'
        ]),


        onGeneralSettingChange(value, settingLabel, label) {
            let params = null

            if (settingLabel === 'catalog') {
                params = { account_type: value ? 'thirdparty_provider' : 'dmp_account' }
                if (value) params.stock_delivery_activated = 'NO'
            }

            this.launchUpdateSetting({
                type: 'general',
                params,
                value,
                settingLabel,
                notificationLabel: label,
                settingsMapper: API_GENERAL_SETTINGS,
                callback: () => {
                    if (name === 'catalog') {
                        this.setSettingName({ name: 'bootstrapPush' })
                        this.setGeneralSetting({
                            type: 'bootstrapPush',
                            activate: false
                        })
                    }
                }
            })
        },

        launchUpdateSetting({ type, value, settingLabel, notificationLabel, settingsMapper, callback, params }) {
            this.processing = true

            if (!params) {
                params = {}
                const settingKey = settingsMapper[settingLabel]
                params[settingKey] = this.setsApiData(value)
            }

            this.updateSettings({ params, type, notificationLabel, settingLabel }).then(() => {
                if (callback) callback()
                this.processing = false
            })
        },

        setCallXDevice() {
            if (!this.callXDevice) this.callXDevice = true
        },

        setsApiData(data) {
            return data ? 'YES' : 'NO'
        },
    }
}
</script>
